import React from "react";
import styles from "../styles/cursos.module.css";

const Cursos: React.FC = () => {
  return (
    <div className={styles.pageNoticias}>
      <div className={styles.containerNoticias}>
        <h1 className={styles.tituloNoticias}>
          Conheça nossos cursos e aprimore seus conhecimentos!
        </h1>
        <p className={styles.descricao}>
          Clique abaixo para acessar a página completa dos cursos na Hotmart.
        </p>
        <a
          href="https://vetviajante1.hotmart.host/nova-pagina-b3263b01-5877-4f25-a785-6ace9d9d77d0"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.botaoHotmart}
        >
          Acessar cursos
        </a>
      </div>
    </div>
  );
};

export default Cursos;
